<template>
  <div class="home">
    <nav-bar />
    <PatientDetailsForm 
      :firstname="firstname" 
      :lastname="lastname"
      :birthname="birthname"
      :birthdate="birthdate"
      :gender="gender"
      :street="street"
      :houseNumber="houseNumber"
      :postCode="postCode"
      :town="town"
      :insuranceNumber="insuranceNumber"
      :organisation="organisation"
      :caseId="caseId"
      :patientId="patientId"
      :secret="secret"
      :redirectUri="redirectUri">
    </PatientDetailsForm>
  </div>
</template>

<script>
// @ is an alias to /src
import PatientDetailsForm from '@/components/PatientDetailsForm.vue';
import NavBar from "@/components/NavBar";

export default {
  name: 'Home',
  components: {
    PatientDetailsForm,
    NavBar
  },
  data() {
    return {
      firstname: this.$route.query.firstname,
      lastname: this.$route.query.lastname,
      birthname: this.$route.query.birthname,
      birthdate: this.$route.query.birthdate,
      gender: this.$route.query.gender,
      street: this.$route.query.street,
      houseNumber: this.$route.query.houseNumber,
      postCode: this.$route.query.postCode,
      town: this.$route.query.town,
      insuranceNumber: this.$route.query.insuranceNumber,
      organisation: this.$route.query.organisation,
      caseId: this.$route.query.caseId,
      patientId: this.$route.query.patientId,
      secret: this.$route.query.secret,
      redirectUri: this.$route.query.redirectUri
    }
  }
}
</script>
